<template>
  <v-container>
    <v-card>
      <v-card-title>
        <div>
          <h5 class="text-h5">
            {{ t("please_upgrade.title") }}
          </h5>
        </div>
      </v-card-title>
      <v-card-text>
        {{
          t("please_upgrade.current_level", { level: currentMerchant.level })
        }}
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'

const { t } = useI18n()
const authStore = useAuthStore()

const currentMerchant = computed(() => authStore.currentMerchant)
</script>
